var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33331 18.3541C9.33331 17.9744 9.64112 17.6666 10.0208 17.6666H19.1875C19.5672 17.6666 19.875 17.9744 19.875 18.3541C19.875 18.7338 19.5672 19.0416 19.1875 19.0416H10.0208C9.64112 19.0416 9.33331 18.7338 9.33331 18.3541Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33331 11.9375C9.33331 11.5578 9.64112 11.25 10.0208 11.25H19.1875C19.5672 11.25 19.875 11.5578 19.875 11.9375C19.875 12.3172 19.5672 12.625 19.1875 12.625H10.0208C9.64112 12.625 9.33331 12.3172 9.33331 11.9375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33331 5.52087C9.33331 5.14118 9.64112 4.83337 10.0208 4.83337H19.1875C19.5672 4.83337 19.875 5.14118 19.875 5.52087C19.875 5.90057 19.5672 6.20837 19.1875 6.20837H10.0208C9.64112 6.20837 9.33331 5.90057 9.33331 5.52087Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8403 3.20136C7.10879 3.46985 7.10879 3.90515 6.8403 4.17364L4.0903 6.92364C3.82182 7.19212 3.38652 7.19212 3.11803 6.92364L2.20136 6.00697C1.93288 5.73848 1.93288 5.30318 2.20136 5.0347C2.46985 4.76621 2.90515 4.76621 3.17364 5.0347L3.60417 5.46523L5.86803 3.20136C6.13652 2.93288 6.57182 2.93288 6.8403 3.20136Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8403 9.61799C7.10879 9.88648 7.10879 10.3218 6.8403 10.5903L4.0903 13.3403C3.82182 13.6087 3.38652 13.6087 3.11803 13.3403L2.20136 12.4236C1.93288 12.1551 1.93288 11.7198 2.20136 11.4513C2.46985 11.1828 2.90515 11.1828 3.17364 11.4513L3.60417 11.8819L5.86803 9.61799C6.13652 9.3495 6.57182 9.3495 6.8403 9.61799Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8403 16.0347C7.10879 16.3032 7.10879 16.7385 6.8403 17.007L4.0903 19.757C3.82182 20.0255 3.38652 20.0255 3.11803 19.757L2.20136 18.8403C1.93288 18.5719 1.93288 18.1366 2.20136 17.8681C2.46985 17.5996 2.90515 17.5996 3.17364 17.8681L3.60417 18.2986L5.86803 16.0347C6.13652 15.7663 6.57182 15.7663 6.8403 16.0347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.ffe3dda94dfc8fa732a2e9b0a4e3482a.svg";
export { ForwardRef as ReactComponent };